var map = {
	"./AdminBuilder": 29,
	"./AdminBuilder.js": 29,
	"./PageRender": 33,
	"./PageRender.js": 33,
	"./admin/ImagePicker": 34,
	"./admin/ImagePicker.js": 34,
	"./admin/MenuEditor": 35,
	"./admin/MenuEditor.js": 35,
	"./frontend/Button": 3,
	"./frontend/Button.js": 3,
	"./frontend/Footer": 24,
	"./frontend/Footer.js": 24,
	"./frontend/Header": 23,
	"./frontend/Header.js": 23,
	"./frontend/SvgTitle": 4,
	"./frontend/SvgTitle.js": 4,
	"./widgets": 5,
	"./widgets/": 5,
	"./widgets/ArticleListWidget": 17,
	"./widgets/ArticleListWidget.js": 17,
	"./widgets/BeforeAndAfterWidget": 20,
	"./widgets/BeforeAndAfterWidget.js": 20,
	"./widgets/CardsWidget": 36,
	"./widgets/CardsWidget.js": 36,
	"./widgets/CtaWidget": 15,
	"./widgets/CtaWidget.js": 15,
	"./widgets/HtmlWidget": 21,
	"./widgets/HtmlWidget.js": 21,
	"./widgets/ImageWidget": 22,
	"./widgets/ImageWidget.js": 22,
	"./widgets/LeadImageWidget": 19,
	"./widgets/LeadImageWidget.js": 19,
	"./widgets/NavigationWidget": 37,
	"./widgets/NavigationWidget.js": 37,
	"./widgets/SectionTitleWidget": 8,
	"./widgets/SectionTitleWidget.js": 8,
	"./widgets/SingleImageWidget": 38,
	"./widgets/SingleImageWidget.js": 38,
	"./widgets/SliderWidget": 39,
	"./widgets/SliderWidget.js": 39,
	"./widgets/SocialCTAWidget": 14,
	"./widgets/SocialCTAWidget.js": 14,
	"./widgets/SpotlightAndQuoteWidget": 13,
	"./widgets/SpotlightAndQuoteWidget.js": 13,
	"./widgets/SpotlightWidget": 16,
	"./widgets/SpotlightWidget.js": 16,
	"./widgets/StatsWidget": 40,
	"./widgets/StatsWidget.js": 40,
	"./widgets/StoryHeaderWidget": 18,
	"./widgets/StoryHeaderWidget.js": 18,
	"./widgets/TextAndImageWidget": 11,
	"./widgets/TextAndImageWidget.js": 11,
	"./widgets/TextAndSidebarWidget": 12,
	"./widgets/TextAndSidebarWidget.js": 12,
	"./widgets/TextBoxTwoColsWidget": 10,
	"./widgets/TextBoxTwoColsWidget.js": 10,
	"./widgets/TextBoxWidget": 9,
	"./widgets/TextBoxWidget.js": 9,
	"./widgets/VideoWidget": 41,
	"./widgets/VideoWidget.js": 41,
	"./widgets/index": 5,
	"./widgets/index.js": 5
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;